import { render, staticRenderFns } from "./SearchHeaderRegions.vue?vue&type=template&id=4ec6aa0b&scoped=true"
import script from "./SearchHeaderRegions.vue?vue&type=script&lang=js"
export * from "./SearchHeaderRegions.vue?vue&type=script&lang=js"
import style0 from "./SearchHeaderRegions.vue?vue&type=style&index=0&id=4ec6aa0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6aa0b",
  null
  
)

export default component.exports